import { Flex, Text } from '@chakra-ui/react';

export const InfoLine = ({
  label, value,
}: { label: string, value?: string | number | null }) => (
  <Flex gap={2} mb={2} align="center">
    <Text fontSize="sm" color="text.muted" fontWeight={600}>{label}:</Text>
    <Text fontSize="md">{value || 'Não informado'}</Text>
  </Flex>
);
